export const TabType = {
  AddPost: "add-post",
  AddArticle: "add-article",
};
